import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";

import ApiService from "@/core/services/ApiService";

const app = createApp(App);

app.use(store);
app.use(router);

ApiService.init(app);

app.mount("#app");
